import { t } from '@lingui/core/macro'

export function ReadGridSelectAllCell({ style }) {
  return (
    <div className="read-grid-cell clickable select-all-cell" style={style}>
      <span id="copyText" style={{ visibility: 'hidden' }}>
        {t`copytext`}
      </span>
    </div>
  )
}
